// Logging utility for Sunday app (tenant-scoped, offline-first)
// Logs errors, sync events, and user actions with timestamp and tenant info

import { getActiveTenantKey } from '../offline/tenant'

export type SundayLogEntry = {
  timestamp: string // ISO string
  tenant: string
  type: 'error' | 'sync' | 'action'
  event: string
  details?: any
}

const LOG_KEY_BASE = 'sunday.logs.v1'

function getLogKey(tenant = getActiveTenantKey()) {
  return `${LOG_KEY_BASE}::${tenant}`
}

function loadLogs(tenant = getActiveTenantKey()): SundayLogEntry[] {
  try {
    const raw = window.localStorage.getItem(getLogKey(tenant))
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

function saveLogs(logs: SundayLogEntry[], tenant = getActiveTenantKey()) {
  window.localStorage.setItem(getLogKey(tenant), JSON.stringify(logs))
}

export function logEvent(type: 'error' | 'sync' | 'action', event: string, details?: any) {
  const tenant = getActiveTenantKey()
  const logs = loadLogs(tenant)
  logs.push({
    timestamp: new Date().toISOString(),
    tenant,
    type,
    event,
    details
  })
  saveLogs(logs, tenant)
}

export function getLogs(tenant = getActiveTenantKey()): SundayLogEntry[] {
  return loadLogs(tenant)
}

export function clearLogs(tenant = getActiveTenantKey()) {
  window.localStorage.removeItem(getLogKey(tenant))
}

export function exportLogs(tenant = getActiveTenantKey()): Blob {
  const logs = loadLogs(tenant)
  const blob = new Blob([JSON.stringify(logs, null, 2)], { type: 'application/json' })
  return blob
}
